var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitefolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "white",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8491 21.1101C25.8491 24.0917 24.0916 25.8492 21.1099 25.8492H14.6249C11.6357 25.8492 9.87492 24.0917 9.87492 21.1101V14.6101C9.87492 11.6326 10.9699 9.87508 13.9524 9.87508H15.6191C16.2174 9.87591 16.7807 10.1567 17.1391 10.6359L17.8999 11.6476C18.2599 12.1259 18.8233 12.4076 19.4216 12.4084H21.7799C24.7691 12.4084 25.8724 13.9301 25.8724 16.9726L25.8491 21.1101Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2342 20.0525H21.5133",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitefolder);
export default __webpack_public_path__ + "static/media/Whitefolder.ae8d5e8e8ba05538572c4f5c11d0664d.svg";
export { ForwardRef as ReactComponent };